import { AxiosError } from "axios";
import { handleApiError } from "./instanceApi";
import { moodleInstanceApi } from "./moodleInstanceApi";
import dayjs from "dayjs";
import {
  CORE_CALENDAR_CREATE_CALENDAR_EVENTS,
  CORE_CALENDAR_DELETE_CALENDAR_EVENTS,
  CORE_CALENDAR_GET_CALENDAR_EVENTS,
} from "../../feature-module/student/student-events/constant";

export const getCalendarEvents = async (params: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: CORE_CALENDAR_GET_CALENDAR_EVENTS,
          ...params,
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching calendar events:", error);
    return handleApiError(error as AxiosError);
  }
};

export const DeleteCalendarEvent = async (eventId: string) => {
  const params = new URLSearchParams();
  params.append("wsfunction", CORE_CALENDAR_DELETE_CALENDAR_EVENTS);
  eventId && params.append("events[0][eventid]", eventId);
  params.append("events[0][repeat]", "0");

  const response = await moodleInstanceApi.post(
    "/webservice/rest/server.php",
    params.toString(),
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );

  return response?.data;
};

export const AddCalendarEvent = async (params: any) => {
  try {
    const timeStart = `${dayjs(params.start).format("YYYY-MM-DD")} ${
      params.start_time
    }`;
    const timeStartLocal = new Date(timeStart.replace(" ", "T"));
    const timeEnd = `${dayjs(params.start).format("YYYY-MM-DD")} ${
      params.end_time
    }`;
    const timeEndLocal = new Date(timeEnd.replace(" ", "T"));
    const unixStartDateTime = Math.floor(timeStartLocal.getTime() / 1000);
    const unixEndDateTime = Math.floor(timeEndLocal.getTime() / 1000);

    const duration = unixEndDateTime - unixStartDateTime;

    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: CORE_CALENDAR_CREATE_CALENDAR_EVENTS,
          "events[0][name]": params.title,
          "events[0][description]": params.description,
          "events[0][eventtype]": "user",
          "events[0][timestart]": unixStartDateTime,
          "events[0][timeduration]": duration || 0,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};
